import React, { Component } from 'react';
import OrderItemProject from './OrderItem/OrderItemProject';
import OrderItemPromotion from './OrderItem/OrderItemPromotion';
import OrderItemSubscription from './OrderItem/OrderItemSubscription';
import ViewMorePagination from '../../Common/ViewMorePagination';
import { getOrderItems } from '../../Common/Providers/OrderListApi';
import camelize from 'camelize';

class OrderItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderItems: [],
      currentPage: 1,
      lastPage: 1,
      perPage: 5
    }
  }

  componentDidMount() {
    this.setInitialOrderItemsState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentOrderPageNumber !== this.props.currentOrderPageNumber) {
      this.setInitialOrderItemsState()
    }
  }

  setInitialOrderItemsState = () => {
    const {
      projects = [],
      promotions = [],
      subscriptions = [],
      promotionGroups = [],
      orderItemsPagination = {
        currentPage: 1,
        lastPage: 1,
        perPage: 5
      }
    } = camelize(this.props);

    this.setState({
      orderItems: projects.concat(promotions, promotionGroups, subscriptions),
      currentPage: orderItemsPagination.currentPage,
      lastPage: orderItemsPagination.lastPage,
      perPage: orderItemsPagination.perPage
    });
  }

  loadMoreOrderItems = (pageNumber) => {
    getOrderItems(this.props.orderNumber, pageNumber).done((response) => {
      if (response.data) {
        const {
          projects = [],
          promotions = [],
          subscriptions = [],
          promotionGroups = [],
          orderItemsPagination = {
            currentPage: 1,
            lastPage: 1,
            perPage: 5
          }
        } = camelize(response.data);

        this.setState((prevState) => ({
          orderItems: prevState.orderItems.concat(projects.concat(promotions, promotionGroups, subscriptions)),
          currentPage: orderItemsPagination.currentPage,
          lastPage: orderItemsPagination.lastPage,
          perPage: orderItemsPagination.perPage
        }));
      }
    });
  }

  render() {
    const {
      currency = ''
    } = this.props

    const separator = <hr className='bg-gray-lighten-2'/>;

    return (
      <div className='p-0 px-md-2'>
        {
          this.state.orderItems.map((orderItem, index) => {
            if (orderItem.type === 'projects') {
              return <OrderItemProject
                separator={separator}
                key={`proj-${index}`}
                id={`${index}`}
                currency={currency}
                {...orderItem}
              />
            } else if (orderItem.type === 'promotions') {
              return <OrderItemPromotion
                separator={separator}
                key={`proj-${index}`}
                id={`${index}`}
                currency={currency}
                {...orderItem}
              />
            } else if (orderItem.type === 'promotionGroups') {
              return <OrderItemPromotion
                separator={separator}
                key={`proj-${index}`}
                id={`${index}`}
                currency={currency}
                {...orderItem}
              />
            } else {
              return <OrderItemSubscription
                separator={separator}
                key={`proj-${index}`}
                id={index}
                currency={currency}
                {...orderItem}
              />
            }
          })
        }
        {this.state.currentPage !== this.state.lastPage && <ViewMorePagination
          lastPageNumber={this.state.lastPage}
          currentPageNumber={this.state.currentPage}
          pageNumberPerPage={this.state.perPage}
          onClick={this.loadMoreOrderItems}
          viewMoreDefaultMessage='Load More'
          viewMoreMessageKey='account.order_orderitems_loadmore'
          className="order-items-load-more"
        />}
      </div>
    );
  }
}

export default OrderItems;



// WEBPACK FOOTER //
// ./src/Account/Order/OrderItems.js